export default __webpack_public_path__ + "static/media/LoyaityManagement.74417cac.png";